import type { PdfiumApi } from "@pdfking/renderer-wasm-pdfium"

const errors: Record<number, string | undefined> = {
  1: "unknown error",
  2: "file not found or could not be opened",
  3: "file not in PDF format or corrupted",
  4: "password required or incorrect password",
  5: "unsupported security scheme",
  6: "page not found or content error",
}

export const GetLastError = async (
  call: PdfiumApi["call"]
): Promise<Error | undefined> => {
  const code = await call("FPDF_GetLastError")
  const message = errors[code]
  return message ? new Error(message) : undefined
}
